import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNavbarHeight, getViewportDimensions } from '../../../models/Utils';
import {
  setHasVisitedCCW
} from '../../../store/reducers/mainReducer';

import { ADALandmarks, ADAARIARoles } from '../../../models/ADA';

import TitleArea from '../subcomponents/TitleArea/TitleArea';
import SlotMachine from '../subcomponents/SlotMachine/SlotMachine';
import ThemeContent from '../subcomponents/ThemeContent/ThemeContent';
import AllThemesGrid from '../subcomponents/AllThemesGrid/AllThemesGrid';
import SpinAgainStrip from '../subcomponents/SpinAgainStrip/SpinAgainStrip';
import CreditsWrapper from '../../BuildingBrighterFutures/subcomponents/CreditsWrapper/CreditsWrapper';

import './CcwMain.scss';

const CcwMain = props => {
  const dispatch = useDispatch();
  const [ heightParams, setHeightParams ] = useState({ marginTop: 0, height: 0 });
  const initialized = useSelector(state => state.data.initialized);
  const cmsData = useSelector(state => state.data.cms.communicationsChangeTheWorld);
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);
  const menuOpened = useSelector(state => state.data.menuOpened);
  let [ada, setADA] = useState("");
  const [chosenTheme, setChosenTheme] = useState(-1);
  const refShownThemes = useRef([]);
  const ccwBlocker = useRef(null);
  const [darkMode, setDarkMode] = useState(false);
  const [chosenThemeForContent, setChosenThemeForContent] = useState(chosenTheme);
  const titleAreaRef = useRef(null);
  const refIsIdleSpinning = useRef(false);
  const refRandomSpinQueued = useRef(false);

  useEffect(() => {
    document.title = "The Verizon Story - Communications Change the World";

    setTimeout(() => {
      dispatch(setHasVisitedCCW(true));
      setADANonRepeating(cmsData.Introduction.AltText);
    }, 100);
  }, []);

  useEffect(() => {

  }, [ada]);

  const handleScroll = () => {
    // if(creditsElement && creditsElement.current){
    //   const sliderRect = creditsElement.current.getBoundingClientRect();
    //   const windowHeight = getViewportDimensions().height;
    //   if ((sliderRect.y <= windowHeight)) {
    //     setCreditsActive(true);
    //   }
    //   else if ((sliderRect.y > windowHeight)) {
    //     setCreditsActive(false);
    //   }
    // }
  };

  const handleResize = () => {
    const marginTop = getNavbarHeight();
    setHeightParams({ marginTop });
  };

  useLayoutEffect(() => {
    // handleScroll();

    // document.body.addEventListener('scroll', handleScroll);
    // window.addEventListener('resize', handleScroll);

    // return () => {
    //   document.body.removeEventListener('scroll', handleScroll);
    //   window.removeEventListener('resize', handleScroll);
    // };
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if(!initialized){
    return null;
  }

  function setADANonRepeating(text) {
    if (ada == text) return;
    console.log("[VBN] Set ADA: ", ada)
    setADA(text);
  }

  function setRandomTheme() {
    if (refIsIdleSpinning.current) {
      refRandomSpinQueued.current = true;
      return;
    }

    refRandomSpinQueued.current = false;
    const filteredIndices = Array.from(Array(cmsData.Themes.length).keys()).filter((i) => !refShownThemes.current.includes(i));
    if (filteredIndices.length) {
      const index = filteredIndices[Math.floor(Math.random() * filteredIndices.length)];
      setChosenTheme(index);
      refShownThemes.current = [...refShownThemes.current, index];
    } else {
      setChosenTheme(-1);
      refShownThemes.current = [];
    }
  }

  function setTargetedTheme(themeIndex) {
    setChosenTheme(themeIndex);
    if (!refShownThemes.current.includes(themeIndex)) {
      refShownThemes.current = [...refShownThemes.current, themeIndex];
    }
  }

  function getLongestTitle() {
    let retValue = cmsData.Introduction.Title;
    cmsData.Themes.forEach((theme) => {
      if (theme.Title.length > retValue.length) {
        retValue = theme.Title;
      }
    });
    return retValue;
  }

  function getLongestSubtitle() {
    let retValue = cmsData.Introduction.Subtitle;
    cmsData.Themes.forEach((theme) => {
      if (theme.Subtitle.length > retValue.length) {
        retValue = theme.Subtitle;
      }
    });
    return retValue;
  }

  const spinStart = () => {
    if (ccwBlocker.current) ccwBlocker.current.style.display = 'block'; 
    setDarkMode(false);
  };

  const spinEnd = () => {
    if (ccwBlocker.current) ccwBlocker.current.style.display = '';
    setDarkMode(chosenTheme !== -1);
    setChosenThemeForContent(chosenTheme);
  };

  const idleSpinStart = () => {
    refIsIdleSpinning.current = true;
    // if (ccwBlocker.current) ccwBlocker.current.style.display = 'block';
  };

  const idleSpinEnd = () => {
    refIsIdleSpinning.current = false;
    if (refRandomSpinQueued.current) {
      setRandomTheme();
    }
    // if (ccwBlocker.current) ccwBlocker.current.style.display = '';
  };

  const goUpAndSpinAgain = (targetTheme) => {
    if (ccwBlocker.current) ccwBlocker.current.style.display = 'block';
    const start = document.body.scrollTop;
    const end = titleAreaRef.current.getBoundingClientRect().top + document.body.scrollTop - heightParams.marginTop;
    // const speed = 1000;
    const t0 = Date.now();
    // const tFinal = t0 + (Math.abs(end - start) / 1000) * speed;
    const tFinal = t0 + 1000;
    const animate = () => {
      let t = Date.now();
      if (t >= tFinal) t = tFinal;
      let tNormalized = (t - t0) / (tFinal - t0);
      const distDiff = (end - start) * (--tNormalized * tNormalized * tNormalized + 1); // easeOutCubic
      document.body.scrollTo(0, start + distDiff);
      if (t < tFinal) {
        requestAnimationFrame(animate);
      } else {
        setTimeout(() => {
          if (ccwBlocker.current) ccwBlocker.current.style.display = '';
          if (typeof targetTheme === 'undefined') {
            setRandomTheme();
          } else {
            setTargetedTheme(targetTheme);
          }
        }, 100);
      }
    };
    requestAnimationFrame(animate);
  };

  return (
    <div className={`ccw-home ${darkMode ? 'dark-bg' : ''}`} role={ADALandmarks.Main}>
      <div className="ccw-all-page-content">
        {/* The div below is a hack for getNavbarHeight() to work */}
        <div className="exhibit-menu-container" style={{ height: 0 }}></div>
        <div style={{ height: `${heightParams.marginTop}px` }}></div>
        <div className="ada-hidden" aria-live="assertive">{ada}</div>
        <TitleArea
          ref={titleAreaRef}
          theme={chosenThemeForContent === -1 ? null : cmsData.Themes[chosenThemeForContent]}
          noThemeData={cmsData.Introduction}
          onSpin={setRandomTheme}
          darkMode={darkMode}
          longestTitle={getLongestTitle()}
          longestSubtitle={getLongestSubtitle()}
        />
        <SlotMachine
          themes={cmsData.Themes}
          themeIndex={chosenTheme}
          onSpinStart={() => { spinStart(); }}
          onSpinEnd={() => { spinEnd(); }}
          onIdleSpinStart={() => { idleSpinStart(); }}
          onIdleSpinEnd={() => { idleSpinEnd(); }}
        />
        {
          chosenThemeForContent > -1
          &&
          <ThemeContent
            cards={cmsData.Themes[chosenThemeForContent].Cards}
            darkMode={darkMode}
          />
        }
        {
          chosenThemeForContent > -1
          &&
          <SpinAgainStrip
            darkMode={darkMode}
            label={cmsData.Introduction.SpinButton.SpinAgainLabel}
            onSpinAgain={() => goUpAndSpinAgain()}
          />
        }
        {
          chosenThemeForContent > -1
          &&
          <AllThemesGrid
            themes={cmsData.Themes}
            currentTheme={chosenThemeForContent === -1 ? null : cmsData.Themes[chosenThemeForContent]}
            exploreButtonLabel={cmsData.Introduction.ExploreThemeLabel}
            darkMode={darkMode}
            onExploreClick={goUpAndSpinAgain}
          />
        }
        {
          chosenThemeForContent > -1
          &&
          <SpinAgainStrip
            darkMode={darkMode}
            label={cmsData.Introduction.SpinButton.SpinAgainLabel}
            onSpinAgain={() => goUpAndSpinAgain()}
          />
        }
        <div className="ccw-bottom-spacer"></div>
      </div>
      <div className="credits-el">
        <CreditsWrapper 
          next=""
          title=""
          subtitle=""
        />
      </div>
      <div className="ccw-blocker" ref={ccwBlocker}></div>
    </div>
  );
};

export default CcwMain;